import { Button, Card, Header, HStack, Image, Text, VStack } from '@direct-frontend/components';
import { CompanyLogo } from '#shared/components/CompanyLogo';
import { getStaticImageUrl } from '#shared/lib/images';
import { useThemeColor } from '#shared/lib/theme';
import { Modal } from '#shared/ui/Modal';
import kitWelcomeBodySrc from './assets/kitWelcomeBody.png';
import { type WelcomeModalViewProps } from './types';
import styles from './WelcomeModal.module.css';

const POINT_FINGER_IMAGE_SRC = 'https://yastatic.net/s3/yastore-static/resources/images/point_finger.png';

export function KitWelcomeModal({
    isOpen,
    onClose,
    onClick,
    'data-testid': dataTestId = 'WelcomeModal',
}: WelcomeModalViewProps) {
    const themeColor = useThemeColor();

    return (
        <Modal data-testid={dataTestId} withoutPaddings className={styles.modal} isOpen={isOpen} onClose={onClose}>
            <VStack alignItems="center" gap="12">
                <VStack alignItems="center" gap="36">
                    <CompanyLogo alt="Логотип" width={328} height={60} theme={themeColor} />
                    <VStack alignItems="center" gap="28">
                        <Header textAlign="center" level="h2">
                            Приступим к открытию вашего нового магазина
                        </Header>
                        <Image alt="Этапы онбординга" width="100%" height="auto" src={kitWelcomeBodySrc} />
                        <Card color="gray" borderRadius="12">
                            <HStack gap="2" className={styles.description}>
                                <Image
                                    alt="Стрелка вверх"
                                    width={24}
                                    height={24}
                                    src={getStaticImageUrl(POINT_FINGER_IMAGE_SRC)}
                                />
                                <Text textAlign="center" role="supplementary">
                                    Выполняйте эти действия в любом удобном для вас порядке
                                </Text>
                            </HStack>
                        </Card>
                    </VStack>
                </VStack>
                <Button size="l" color="accent" width="max" onClick={onClick} data-testid={`${dataTestId}.StartButton`}>
                    Поехали!
                </Button>
            </VStack>
        </Modal>
    );
}
